<script>
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  defineComponent,
  reactive,
  ref,
  computed,
  nextTick,
  watch,
} from "@vue/composition-api";
import moment from "moment";
import {
  CheckRecordServiceProxy,
  CheckProjectServiceProxy,
  DeviceTypeCheckProjectServiceProxy,
  CheckItemServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import {
  DeviceTypeServiceProxy,
  DeviceServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import Upload from "@/components/DForm/components/Upload";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { downloadFile as download, momentFormat, confirmDelete } from "@/utils";
import { checkRecord, checkItem } from "./api";
import useTable from "@/hooks/useTable";
import { cloneDeep } from "lodash";
import CodeModel from "@/components/CodeModel/index";
import dayjs from 'dayjs';
import previewImg from "@/components/PreviewImg/index.vue";
import { getImg, getTxt } from "@/utils";
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

const crsp = new CheckRecordServiceProxy();
const dtsp = new DeviceTypeServiceProxy();
const dsp = new DeviceServiceProxy();
const esp = new EmployeeServiceProxy();
const cpsp = new CheckProjectServiceProxy();
const dtcpsp = new DeviceTypeCheckProjectServiceProxy();
const cisp = new CheckItemServiceProxy();
const csp = new CodeRuleServiceProxy();

function isEmptyArray(value) {
  return value.length === 0;
}

export default defineComponent({
  name: "check-record",
  components: {
    Upload,
    CodeModel,
    previewImg,
  },
  setup(_, { root }) {
    const {
      tableAttrs: topTableProps,
      currentRecord,
      isUpdatable,
      isDeletable,
      create: createCheckRecord,
      update: updateCheckRecord,
      read: getTopTableData,
      del: deleteCheckRecord,
    } = useTable(
      {
        columns: [
          {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" },
            width: 140,
            i18n: "actions",
          },
          {
            title: "点检单号",
            dataIndex: "checkCode",
            width: 140,
            i18n: "page_tpm_check_record_code",
          },
          {
            title: "设备编码",
            dataIndex: "deviceCode",
            width: 140,
            i18n: "page_tpm_check_device_code",
          },
          {
            title: "设备名称",
            dataIndex: "deviceName",
            width: 140,
            i18n: "page_tpm_check_device_name",
          },
          {
            title: "设备类型",
            dataIndex: "deviceTypeName",
            width: 140,
            i18n: "page_tpm_check_device_type",
          },
          {
            title: "点检时间",
            dataIndex: "checkTime",
            scopedSlots: { customRender: "checkTime" },
            width: 140,
            i18n: "page_tpm_check_record_time",
          },
          {
            title: "检验人员",
            dataIndex: "checkUserName",
            width: 140,
            i18n: "page_tpm_check_record_person",
          },
          {
            title: "检验项目",
            dataIndex: "checkProjectName",
            width: 140,
            i18n: "page_tpm_check_record_project",
          },
          {
            title: "检验结果",
            dataIndex: "checkResult",
            scopedSlots: { customRender: "checkResult" },
            i18n: "page_tpm_check_record_result",
          },
        ],
        canChangeColWidth: true,
        canFixedHead: true,
        scroll: { x: 1200 },
      },
      checkRecord,
 
      (record) =>
        getBottomTableData(
          record.id,
          (bottomTableProps.pagination.current = 1),
          bottomTableProps.pagination.pageSize
        ),
      (page, pageSize) =>
        getTopTableData(
          page,
          searchBody.deviceTypeId || undefined,
          searchBody.keyword,
          pageSize,
          searchBody.startTime,
          searchBody.endTime
        ),
      () => {
        if (bottomTableProps) bottomTableProps.dataSource = [];
      }
    );

    const searchBody = reactive({
      current: 1,
      deviceTypeId: "",
      size: 999,
      keyword: "",
      startTime: '',
      endTime: ''
    });

    const deleteRecord = async () => {
      await confirmDelete(
        deleteCheckRecord,
        topTableProps.rowSelection.selectedRowKeys
      );
      getTopTableData(
        topTableProps.pagination.current,
        searchBody.deviceTypeId || undefined,
        searchBody.keyword,
        topTableProps.pagination.pageSize,
        searchBody.startTime,
        searchBody.endTime
      );
    };
    const isShow = ref(false);
    const isEditing = ref(false);
    const search = (value) => {
      topTableProps.pagination.current = 1;
      getTopTableData(
        topTableProps.pagination.current,
        searchBody.deviceTypeId || undefined,
        value,
        topTableProps.pagination.pageSize,
        searchBody.startTime,
        searchBody.endTime

      );
    };
    const onChange = ($event) => {
      if ($event && $event.length > 0) {
        searchBody.startTime = dayjs($event[0]).format( 'YYYY-MM-DD hh:mm:ss')
        searchBody.endTime = dayjs($event[1]).format( 'YYYY-MM-DD hh:mm:ss')
      } else {
        searchBody.startTime = ''
        searchBody.endTime = ''

      }
    }
    const setCurrentRecordFiles = async (id) => {
      
      const res = await crsp.checkRecordFileList(id);
      currentRecord.value.checkRecordFileList = res;
    };

    const { tableAttrs: bottomTableProps, read: getBottomTableData } = useTable(
      {
        columns: [
          {
            title: "点检项",
            dataIndex: "name",
            width: 140,
            i18n: "page_tpm_check_item_name",
          },
          {
            title: "标准数值",
            dataIndex: "standardValue",
            width: 140,
            i18n: "page_tpm_check_item_standard",
          },
          {
            title: "检验数值",
            dataIndex: "checkValue",
            width: 140,
            i18n: "page_tpm_check_record_value",
          },
        ],
        rowSelection: null,
      },
      checkItem,
      undefined,
      (page, pageSize) =>
        getBottomTableData(currentRecord.value.id, page, pageSize)
    );
    const showCode = ref(false);
    const dataList = ref([]);
    const show = ref(true);
    const deviceType = ref([]);
    const checkRecordList = ref();
    const previewVisible = ref(false);
    const previewIndex = ref();
    const imgList = ref([]);
    const encode = ref("UTF-8");

    const print = () => {
      getList();
      showCode.value = true;
    };
    const idList = ref([]);
    const getList = () => {
      topTableProps.dataSource.forEach((item) => {
        idList.value = item.id;
      });
      topTableProps.dataSource.map((t) => {
        topTableProps.rowSelection.selectedRowKeys.map((item) => {
          if (t.id === item) {
            dataList.value.push({
              code: t.checkCode,
              name: t.deviceName,
            });
          }
        });
      });
    };
    const cancel = () => {
      showCode.value = false;
    };
    const getDeviceType = async () => {
      const res = await dtsp.pageDeviceType({
        keyWord: "",
        query: {
          current: 1,
          size: 999,
        },
      });
      deviceType.value = res.records;
      deviceType.value.unshift({
        name: root.$t("page_plan_maintenance_all_types" || "全部类型"),
        id: "",
      });
    };

    const createModalProps = reactive({
      title: root.$t("page_tpm_check_record_create") || "添加点检记录",
      visible: false,
      width: 1024,
      destroyOnClose: true,
      confirmLoading: false,
      okText: root.$t("page_calendar_add") || "添加",
    });
    const openCreateModal = () => {
      show.value = true;
      createModalProps.title =
        root.$t("page_tpm_check_record_create") || "添加点检记录";
      createModalProps.okText = root.$t("page_calendar_add") || "添加";
      isEditing.value = false;
      clear();
      createModalProps.visible = true;
    };
    const closeCreateModal = () => {
      createModalProps.visible = false;
      clear();
    };
    const submit = async () => {
      createModalProps.confirmLoading = true;
      try {
        const values = await validate();
        // 接口
        if (!isEditing.value) {
          const body = createBody(values);
          await createCheckRecord(body);
        } else {
          const body = updateBody(values);
          await updateCheckRecord(body);
        }
        createModalProps.confirmLoading = false;
        createModalProps.visible = false;
        getTopTableData(
          topTableProps.pagination.current,
          searchBody.deviceTypeId || undefined,
          searchBody.keyword,
          topTableProps.pagination.pageSize,
          searchBody.startTime,
          searchBody.endTime
        );
      } catch (e) {
        createModalProps.confirmLoading = false;
        throw e;
      }
    };
    const createBody = (form) => {
      return {
        /** 点检记录code */
        checkCode: form.checkCode,
        /** 点检项目编码 */
        checkProjectCode: currentProject.value.code,
        /** 点检项目id */
        checkProjectId: currentProject.value.checkProjectId,
        /** 点检项目名称 */
        checkProjectName: currentProject.value.name,
        /** 点检记录附件 */
        checkRecordFileList: form.checkRecordFileList.map((item) => ({
          contentType: item.contentType,
          fileName: item.filename, 
          objectKey: item.objectKey, 
        })),
        /** 点检记录点检项 */
        checkRecordItemList: itemTableProps.dataSource.map((item) => ({
          checkValue: item.checkValue || "",
          name: item.name,
          standardValue: item.standardValue,
          itemId: item.id,
        })),
        /** 点检结果(0: 不正常；1: 正常) */
        checkResult: form.checkResult,
        /** 点检时间 */
        checkTime: momentFormat(form.checkTime),
        /** 检验人员id */
        checkUserId: form.checkUserId,
        /** 检验人员名称 */
        checkUserName: currentEmployee.value.name,
        /** 设备编码 */
        deviceCode: form.deviceCode,
        /** 设备id */
        deviceId: currentDevice.value.workStationId,
        /** 设备名称 */
        deviceName: currentDevice.value.name,
        /** 设备类型 */
        deviceTypeId: currentDevice.value.deviceTypeId,
        /** 设备类型名称 */
        deviceTypeName: currentDevice.value.deviceTypeName,
        /** 规则Id */
        codeRuleId: form.codeRuleId,
        /** 点检描述 */
        remark: form.remark,
      };
    };
    const updateBody = (form) => {
      return {
        /** 点检记录code */
        checkCode: form.checkCode,
        /** 点检项目编码 */
        checkProjectCode: currentProject.value.code,
        /** 点检项目id */
        checkProjectId: currentProject.value.checkProjectId,
        /** 点检项目名称 */
        checkProjectName: currentProject.value.name,
        /** 点检记录附件 */
        checkRecordFileList: form.checkRecordFileList.map((item) => ({ 
          contentType: item.contentType, 
          fileName: item.fileName || item.filename, 
          objectKey: item.objectKey, 
        })), 
        /** 点检记录点检项 */
        checkRecordItemList: itemTableProps.dataSource.map((item) => ({
          checkValue: item.checkValue,
          name: item.name,
          standardValue: item.standardValue,
          itemId: item.id,
        })),
        /** 点检结果(0: 不正常；1: 正常) */
        checkResult: form.checkResult,
        /** 点检时间 */
        checkTime: form.checkTime.format("YYYY-MM-DD HH:mm:ss"),
        /** 检验人员id */
        checkUserId: form.checkUserId,
        /** 检验人员名称 */
        checkUserName: currentEmployee.value.name,
        /** 设备编码 */
        deviceCode: form.deviceCode,
        /** 设备id */
        deviceId: currentDevice.value.workStationId,
        /** 设备名称 */
        deviceName: currentDevice.value.name,
        /** 设备类型 */
        deviceTypeId: currentDevice.value.deviceTypeId,
        /** 设备类型名称 */
        deviceTypeName: currentDevice.value.deviceTypeName,
        /** 点检描述 */
        remark: form.remark,
        /** 规则Id */
        codeRuleId: form.codeRuleId,
        /** 点检记录id */
        id: currentRecord.value.id,
      };
    };
    const openUpdateModal = async () => {
      isEditing.value = true;
      show.value = false;
      createModalProps.title =
        root.$t("page_tpm_check_record_edit") || "编辑点检记录";
      createModalProps.okText = root.$t("submit") || "提交";
      createModalProps.visible = true;

      await nextTick();

      createFormProps.form.setFieldsValue({
        checkCode: currentRecord.value.checkCode,
      });
      createFormProps.form.setFieldsValue({
        checkResult: currentRecord.value.checkResult,
      });
      createFormProps.form.setFieldsValue({
        remark: currentRecord.value.remark,
      });
      createFormProps.form.setFieldsValue({
        checkUserId: currentRecord.value.checkUserId,
      });
      createFormProps.form.setFieldsValue({
        deviceCode: currentRecord.value.deviceCode,
      });
      createFormProps.form.setFieldsValue({
        checkTime: moment(currentRecord.value.checkTime),
      });
      createFormProps.form.setFieldsValue({
        deviceTypeName: currentRecord.value.deviceTypeName,
      });

      setCurrentEmployee(currentRecord.value.checkUserId);
      await setCurrentDevice(currentRecord.value.deviceCode);
      await setCurrentProject(currentRecord.value.checkProjectId);
      createFormProps.form.setFieldsValue({
        checkProjectId: currentRecord.value.checkProjectId,
      });
      await setCurrentRecordFiles(currentRecord.value.id);
      createFormProps.form.setFieldsValue({
        checkRecordFileList: currentRecord.value.checkRecordFileList,
      });
    };

    const createFormProps = reactive({
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      selfUpdate: true,
      form: root.$form.createForm(root),
    });
    const validate = () => {
      return new Promise((resolve, reject) => {
        createFormProps.form.validateFields((err, values) => {
          if (err) reject(err);
          else resolve(values);
        });
      });
    };
    const checkPlanList = ref([]);
    const changeRecordPlan = async () => {
      const res = await csp.list("CheckRecordObject");
      checkPlanList.value = res;
    };
    const deviceList = ref([]);
    const getDeviceList = async () => {
      const res = await dsp.getDeviceList();
      deviceList.value = res.filter((item) => !!item.name && !!item.code);
    };
    const currentDevice = ref({});
    const setCurrentDevice = async (value) => {
      currentDevice.value =
        deviceList.value.find((item) => item.code === value) || {};
      await getProjectList(currentDevice.value.deviceTypeId);
    };

    const employeeList = ref([]);
    const getEmployeeList = async () => {
      const res = await esp.getPageEmployees(1, { statusList: [1] }, "", 999);
      employeeList.value = res.records;
    };
    const currentEmployee = ref({});
    const setCurrentEmployee = (value) => {
      currentEmployee.value =
        employeeList.value.find((item) => item.id === value) || {};
    };

    const projectList = ref([]);
    const getProjectList = async (id) => {
      if (!id) {
        currentProject.value = {};
        projectList.value = [];
        createFormProps.form.setFieldsValue({ checkProjectId: null });
        itemTableProps.dataSource = [];
        return;
      }
      const res = await dtcpsp.getDeviceTypeCheckProjects(id);
      projectList.value = res;
      if (!isEditing.value) {
        createFormProps.form.setFieldsValue({ checkProjectId: null });
        currentProject.value = {};
        itemTableProps.dataSource = [];
      }
    };
    const currentProject = ref({});
    const setCurrentProject = async (projectId) => {
      itemTableProps.loading = true;
      currentProject.value =
        projectList.value.find((item) => item.checkProjectId === projectId) ||
        {};
      if (!currentProject.value.id) {
        itemTableProps.loading = false;
        return;
      }
      const res = await cpsp.getCheckProjectAndItemById(
        currentProject.value.checkProjectId
      );
      currentProject.value.list = res.list;
      itemTableProps.dataSource =
        currentProject.value.list.map((item) => ({
          ...item,
          checkValue: !isEditing.value
            ? ""
            : bottomTableProps.dataSource.find((ite) => ite.name === item.name)
                ?.checkValue,
        })) || [];
      itemTableProps.loading = false;
    };

    const clear = () => {
      currentDevice.value = {};
      currentEmployee.value = {};
      currentProject.value = {};
      itemTableProps.dataSource = [];
      projectList.value = [];
      isShow.value = false;
    };

    const { tableAttrs: itemTableProps, read: getItemTableData } = useTable(
      {
        columns: [
          {
            title: "编辑",
            key: "action",
            scopedSlots: { customRender: "action" },
            i18n: "edit",
          },
          {
            title: "点检项",
            dataIndex: "name",
            i18n: "page_tpm_check_item_name",
          },
          {
            title: "标准数值",
            dataIndex: "standardValue",
            i18n: "page_tpm_check_item_standard",
          },
          {
            title: "检验数值",
            dataIndex: "checkValue",
            scopedSlots: { customRender: "checkValue" },
            i18n: "page_tpm_check_record_value",
          },
        ],
        rowSelection: null,
        pagination: false,
      },
      {
        read: cisp.pageCheckItems.bind(cisp),
      }
    );

    const deleteItem = (index) => {
      itemTableProps.dataSource.splice(index, 1);
      // currentProject.value.list.splice(index, 1)
    };

    const fileModalProps = reactive({
      title: root.$t("page_tpm_check_watch_file") || "查看附件",
      visible: false,
      width: 1024,
      destroyOnClose: true,
      okButtonProps: { style: { display: "none" } },
    });
    const currentFiles = ref([]);
    const fileSrcs = ref([]);
    const fileFormData = reactive({
      galleryVisible: false,
      currentIndex: 0,
    });
    function changeEncode(val) {
      encode.value = val;
      getCurrentFiles();
    }
    const openFileModal = async (record) => {
      currentFiles.value = await crsp.checkRecordFileList(record.id);
      fileModalProps.visible = true;
      getCurrentFiles();
    };
    let resizeTimer = null
    const changeY = () => {
      if (resizeTimer) {
        clearTimeout(resizeTimer)
        resizeTimer = null
      }
      resizeTimer = setTimeout(function() {
        const topScrollHeight = document.getElementById('check-record-top').clientHeight - 96
        const topTableBody = document.querySelector('#check-record-top .ant-table-body')
        if (topTableBody) {
          topTableBody.style.maxHeight = topScrollHeight + 'px'
        }
        const bottomScrollHeight = document.getElementById('check-record-bottom').clientHeight - 102
        const bottomTableBody = document.querySelector('#check-record-bottom .ant-table-body')
        if (bottomTableBody) {
          bottomTableBody.style.maxHeight = bottomScrollHeight + 'px'
        }
      }, 100)
    }
    const getCurrentFiles = () => {
      imgList.value = [];
      
      currentFiles.value.map(async (file, index) => {
        let content;

        if (
          file.contentType != "image/jpg" &&
          file.contentType != "image/jpeg" &&
          file.contentType != "image/png" &&
          file.contentType != "image/svg" &&
          file.contentType != "image/gif" &&
          file.contentType != "text/txt" &&
          file.contentType != "text/json" &&
          file.contentType != "application/pdf" &&
          file.contentType != "application/swf" &&
          file.contentType != "image/octet-stream"
        ) {
          file.contentType = "text/txt";
          content = await getTxt(file, encode.value);
        }

        if (file.contentType.indexOf("image") > -1) {
          content = await getImg(file);
        }


        if (file.contentType.indexOf("pdf") > -1) {
          content = await (
            await resourceService.statFileUsingGET(file.objectKey)
          ).data.link;
        }

        let temp = {
          type: file.contentType.substring(0, file.contentType.indexOf("/")),
          content,
        };
        fileSrcs.value[index] = temp;
        fileSrcs.value = cloneDeep(fileSrcs.value);
      });
    };

    const closeFileModal = () => {
      fileModalProps.visible = false;
      fileSrcs.value = [];
    };

    const showTotal = (total) => {
      return this.$t('Total…items').replace('{0}', total)
    }

    const changeCheckRecord = (val) => {
      if (val) {
        createFormProps.form.setFieldsValue({ checkCode: "" });
        isShow.value = true;
      } else {
        isShow.value = false;
      }
    };
    function openPreview(i, arr) {
      this.previewVisible = true;
      this.previewIndex = i;
    }
    function closePreview() {
      this.previewVisible = false;
    }

    async function handleExport() {
      const res = await checkRecord.export({
        ids: topTableProps.dataSource
          .map((item) => item.id)
          .filter((id) =>
            topTableProps.rowSelection.selectedRowKeys.includes(id)
          ),
      });
      download(res, root.$t("page_tpm_check_record") + ".xlsx");
    }
    watch(
      () => searchBody.deviceTypeId,
      (val) => {
        getTopTableData(
          topTableProps.pagination.current,
          val || undefined,
          searchBody.keyword,
          topTableProps.pagination.pageSize,
          searchBody.startTime,
         searchBody.endTime
        );
      }
    );
    watch(
      () => searchBody.startTime,
      (val) => {
          getTopTableData(
            topTableProps.pagination.current,
            searchBody.deviceTypeId || undefined,
            searchBody.keyword,
            topTableProps.pagination.pageSize,
            val,
            searchBody.endTime
          );
      }
    );

    watch(
      () => searchBody.endTime,
      (val) => {
          getTopTableData(
            topTableProps.pagination.current,
            searchBody.deviceTypeId || undefined,
            searchBody.keyword,
            topTableProps.pagination.pageSize,
            searchBody.startTime,
            val
          );
      }
    );
    const handleTableChange = (current, pageSize) => {
      topTableProps.pagination.current = current
      topTableProps.pagination.pageSize = pageSize
      getTopTableData(
        topTableProps.pagination.current,
        searchBody.deviceTypeId,
        searchBody.keyword,
        topTableProps.pagination.pageSize,
        searchBody.startTime,
        searchBody.endTime
      )
    }

    // created
    getDeviceType();
    getDeviceList();
    getEmployeeList();
    changeRecordPlan();
    getTopTableData(
      topTableProps.pagination.current,
      searchBody.deviceTypeId,
      searchBody.keyword,
      topTableProps.pagination.pageSize,
      searchBody.startTime,
      searchBody.endTime
    );

    return {
      searchBody,
      search,
      onChange,
      handleTableChange,
      showTotal,
      currentRecord,
      isUpdatable,
      topTableProps,
      bottomTableProps,
      isDeletable,
      deleteRecord,
      isEditing,
      isShow,
      deviceType,

      createModalProps,
      openCreateModal,
      closeCreateModal,
      submit,
      openUpdateModal,

      createFormProps,

      deviceList,
      checkPlanList,
      currentDevice,
      setCurrentDevice,

      employeeList,
      currentEmployee,
      setCurrentEmployee,

      projectList,
      getProjectList,
      currentProject,
      setCurrentProject,

      itemTableProps,
      deleteItem,

      moment,

      fileModalProps,
      currentFiles,
      openFileModal,
      closeFileModal,
      fileSrcs,
      getCurrentFiles,

      handleExport,
      fileFormData,
      checkRecordList,
      show,
      dataList,
      getList,
      cancel,
      print,
      idList,
      showCode,
      changeCheckRecord,
      openPreview,
      closePreview,
      previewVisible,
      previewIndex,
      imgList,
      changeEncode,
      encode,
      changeY      
    };
  },
});
</script>

<template>
  <div style="height: 100%">
    <div class="d-flex">
      <a-button
        v-acl="'page_tpm_check_record_create'"
        type="primary"
        @click="openCreateModal"
        >{{ $t("page_tpm_check_record_create") || "添加点检记录" }}</a-button
      >
      <a-button
        v-acl="'page_tpm_check_record_edit'"
        class="ml-2"
        :disabled="!isUpdatable"
        @click="openUpdateModal"
        >{{ $t("edit") || "编辑" }}</a-button
      >
      <a-button
        v-acl="'page_tpm_check_record_delete'"
        class="ml-2"
        type="danger"
        :disabled="!isDeletable"
        @click="deleteRecord"
        >{{ $t("delete") || "删除" }}</a-button
      >
      <a-button
        v-acl="'page_tpm_check_record_export'"
        class="ml-2"
        :disabled="!isDeletable"
        @click="handleExport"
        >{{ $t("page_product_export") || "导出" }}</a-button
      >
      <a-button @click="print" :disabled="!isDeletable" class="ml-2">{{
        $t("page_print_code")
      }}</a-button>
      <div style="margin-left: auto">
        <a-range-picker @change="onChange" show-time />
  
        <a-select
        show-search
        optionFilterProp="children"
          v-model="searchBody.deviceTypeId"
          :placeholder="$t('please_select') + $t('page_tpm_check_device_type') || '设备类型'"
          allowClear
          style="margin-left: 8px; width: 120px"
        >
          <a-select-option
            v-for="item in deviceType"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
  
        <!-- <a-button class="ml-2">高级搜索</a-button> -->
  
        <a-input-search
          :placeholder="$t('please_select') + $t('keyword')"
          v-model="searchBody.keyword"
          class="ml-2"
          style="width: 240px"
          @search="search"
          :enterButton="$t('search')"
        />
      </div>
    </div>

    <div
      class="mt-4"
      style="background: #fff; height: calc(100% - 48px); overflow-y: scroll"
    >
    <div id="check-record-top" class="check-record-top">
      <ml-table v-bind="topTableProps"   
          :pagination="{
            size: 'big',
            total: topTableProps.pagination.total,
            // showTotal: (total) => `${showTotal(total)}`,
            pageSize: topTableProps.pagination.pageSize,
            current: topTableProps.pagination.current,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            onChange: handleTableChange,
            onShowSizeChange: handleTableChange
          }"  :scroll="{y: 500}">
        <template #action="record">
          <a @click="openFileModal(record)">{{
            $t("page_tpm_check_watch_file") || "查看附件"
          }}</a>
        </template>
        <template #checkTime="time">
          {{ moment(time).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template #checkResult="result">
          {{
            result === 0
              ? $t("page_tpm_check_record_bad" || "异常")
              : $t("page_tpm_check_record_good" || "正常")
          }}
        </template>
      </ml-table>
    </div>
      <div v-resize="{axis: 'y', cb: this.changeY }"></div>
    <div id="check-record-bottom" class="check-record-bottom">
      <ml-table v-bind="bottomTableProps" :scroll="{y: 500}"> </ml-table>
    </div>
    </div>

    <a-modal v-bind="createModalProps" @cancel="closeCreateModal" @ok="submit">
      <a-form v-bind="createFormProps">
        <a-row>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_system_coding_rules')"
              :style="{ display: show ? 'block' : 'none' }"
            >
              <a-select
              show-search
              optionFilterProp="children"
                :allowClear="true"
                style="width: 100%"
                :placeholder="$t('please_select') + $t('page_system_coding_rules')"
                @change="changeCheckRecord"
                v-decorator="['codeRuleId']"
              >
                <a-select-option
                  :key="index"
                  :value="item.id"
                  v-for="(item, index) in checkPlanList"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_code') || '点检单号'"
            >
              <a-input
                v-decorator="['checkCode']"
                :placeholder="$t('common_please_input') + $t('page_tpm_check_record_code') || '点检单号'"
                :disabled="isShow || isEditing"
                :max-length="100"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_device_code') || '设备编码'"
            >
              <a-select
              show-search
              optionFilterProp="children"
                :placeholder="$t('please_select') + $t('page_tpm_check_device_code') || '设备编码'"
                v-decorator="[
                  'deviceCode',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('page_dform_must') || '必填项',
                      },
                    ],
                  },
                ]"
                :disabled="isEditing"
                @change="setCurrentDevice"
              >
                <a-select-option
                  v-for="item in deviceList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.code }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_device_name') || '设备名称'"
            >
              <a-input disabled :value="currentDevice.name" 
                :placeholder="$t('common_please_input') + $t('page_tpm_check_device_name') || '设备名称'"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_device_type') || '设备类型'"
            >
              <a-input disabled :value="currentDevice.deviceTypeName"
                :placeholder="$t('common_please_input') + $t('page_tpm_check_device_type') || '设备类型'" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_device_rule') || '规格型号'"
            >
              <a-input disabled :value="currentDevice.standardModel"
                :placeholder="$t('common_please_input') + $t('page_tpm_check_device_rule') || '规格型号'" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_person') || '检验人员'"
            >
              <a-select
                show-search
                optionFilterProp="children"
                v-decorator="['checkUserId']"
                :placeholder="$t('please_select') + $t('page_tpm_check_record_person') || '检验人员'"
                :disabled="isEditing"
                @change="setCurrentEmployee"
              >
                <a-select-option
                  v-for="item in employeeList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_time') || '点检时间'"
            >
              <a-date-picker
                :placeholder="$t('please_select') + $t('page_tpm_check_record_time') || '点检时间'"
                v-decorator="[
                  'checkTime',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('page_dform_must') || '必填项',
                      },
                    ],
                  },
                ]"
                :disabled="isEditing"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_result') || '点检结果'"
            >
              <a-select
                show-search
                optionFilterProp="children"
                :placeholder="$t('please_select') + $t('page_tpm_check_record_result') || '点检结果'"
                v-decorator="[
                  'checkResult',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('page_dform_must') || '必填项',
                      },
                    ],
                  },
                ]"
              >
                <a-select-option :value="0">
                  {{ $t("page_tpm_check_record_bad") || "异常" }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t("page_tpm_check_record_good") || "正常" }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_project') || '点检项目'"
            >
              <a-select
                :placeholder="$t('please_select') + $t('page_tpm_check_record_project') || '点检项目'"
                v-decorator="[
                  'checkProjectId',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('page_dform_must') || '必填项',
                      },
                    ],
                  },
                ]"
                @change="setCurrentProject"
              >
                <a-select-option
                  v-for="item in projectList"
                  :key="item.checkProjectId"
                  :value="item.checkProjectId"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_remark') || '详细情况描述'"
            >
              <a-textarea
                :placeholder="$t('common_please_input') + $t('page_tpm_check_record_remark') || '详细情况描述'"
                v-decorator="['remark', { rules: [{ max: 100 }] }]"
                :maxLength="100"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <ml-table v-bind="itemTableProps" class="mb-4">
              <template #action="_, __, index">
                <a-popconfirm
                  :title="$t('page_resource_pool_confirm_delete')"
                  :ok-text="$t('yes')"
                  :cancel-text="$t('no')"
                  @confirm="deleteItem(index)"
                >
                  <a style="color: var(--color-red)">{{
                    $t("delete") || "删除"
                  }}</a>
                </a-popconfirm>
              </template>
              <template #checkValue="_, record">
                <a-input :placeholder="$t('common_please_input') + $t('page_tpm_check_record_value') || '检验数值'" v-model="record.checkValue" :maxLength="48" />
              </template>
            </ml-table>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('page_tpm_check_record_file') || '点检附件'"
            >
              <Upload
                v-decorator="['checkRecordFileList', { initialValue: [] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <a-modal v-bind="fileModalProps" @cancel="closeFileModal">
      <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 12 }">
        <a-form-item :label="$t('page_tpm_check_record_file') || '点检附件'">
          <ul>
            <li v-for="(item, index) in fileSrcs" :key="index">
              <div class="img-panel">
                <img
                  v-if="item && item.type && item.type === 'image'"
                  :src="item.content"
                  @click="openPreview(index)"
                  style="cursor: pointer"
                />
                <div
                  @click="openPreview(index)"
                  style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
                ></div>
                <embed
                  v-if="item && item.type && item.type === 'application'"
                  :src="item.content"
                  type="application/pdf"
                  style="cursor: pointer"
                />
                <div
                  v-if="item && item.type && item.type === 'text'"
                  @click="openPreview(index)"
                >
                  <textarea
                    :placeholder="$t('common_please_input') + $t('page_tpm_check_record_file') || '点检附件'"
                    class="txt-content"
                    v-model="item.content"
                    style="cursor: pointer; color:#000000;"
                    disabled
                  />
                </div>
              </div>
            </li>
          </ul>
        </a-form-item>
        <a-form-item
          :label="$t('page_tpm_check_record_remark') || '详细情况描述'"
        >
          <a-textarea :value="currentRecord.remark" disabled
                :placeholder="$t('page_tpm_check_record_remark') || '详细情况描述'" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- <gallery
      :imgs="fileSrcs"
      :visible="fileFormData.galleryVisible"
      :index="fileFormData.currentIndex"
      @cancel="() => (fileFormData.galleryVisible = false)"
    ></gallery> -->
    <previewImg
      :visible="previewVisible"
      :imgs="fileSrcs"
      :index="previewIndex"
      @cancel="closePreview"
      @changeEncode="changeEncode"
    />
    <CodeModel :visible="showCode" :dataList="dataList" @cancel="cancel" />
  </div>
</template>

<style lang="less" scoped>
// .check-record-top{
//   height: 420px;
// }
.check-record-bottom{
  height: calc(100% - 428px);
}
.img-panel {
  margin-bottom: 10px;
  background-color: #fafafa;
  color: #00000025;
  border: 1px solid #00000025;
  width: 192px;
  height: 178px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}

.clickRowStyl {
  background-color: #fff1b8 !important;
  td {
    background-color: #fff1b8 !important;
  }
}
.secondColor {
  background-color: #f8f8f8 !important;
  td {
    background-color: #f8f8f8 !important;
  }
}
</style>
